import { Navigate } from "react-router-dom";
import { lazy } from 'react';
import Protected from "../components/Wrappers/Protected";

const Verification = lazy(() => import("../pages/Verification/Verification"));
const CheckUser = lazy(() => import("../pages/CheckUser/CheckUser"));
const OTP = lazy(() => import("../pages/OTP/OTP"));
const Home = lazy(() => import("../pages/Home/Home"));
const YourCrops = lazy(() => import("../pages/YourCrops"));
const CropDetails = lazy(() => import("../pages/CropDetails/CropDetails"));
const CropDetailsSolution = lazy(() => import("../pages/CropDetailsSolution/CropDetailsSolution"));
const PersonalInfo = lazy(() => import("../pages/PersonalInfo"));
const Subscription = lazy(() => import("../pages/Subscription/Subscription"));
const ConfirmSubscription = lazy(() => import("../pages/ConfirmSubscription/ConfirmSubscription"));
const Videos = lazy(() => import("../pages/Videos/Videos"));
const VideoPlayer = lazy(() => import("../pages/VideoPlayer"));
const MandiRates = lazy(() => import("../pages/MandiRates"));
const Market = lazy(() => import("../pages/MarketPlace"));
const Offers = lazy(() => import("../pages/MarketPlace/pages/Offers"));
const TodayOffers = lazy(() => import("../pages/MarketPlace/pages/TodayOffers"));
const MarketCategory = lazy(() => import("../pages/MarketPlace/pages/Category"));
const MarketBrand = lazy(() => import("../pages/MarketPlace/pages/Brand"));
const SuggestedProducts = lazy(() => import("../pages/MarketPlace/pages/SuggestedProducts"));
const BestSelling = lazy(() => import("../pages/MarketPlace/pages/BestSelling"));
const ProductPage = lazy(() => import("../pages/MarketPlace/pages/ProductPage"));
const MyCart = lazy(() => import("../pages/MarketPlace/pages/MyCart"));
const Checkout = lazy(() => import("../pages/MarketPlace/pages/Checkout"));
const OrderPlaced = lazy(() => import("../pages/MarketPlace/pages/OrderPlaced"));
const MyOrders = lazy(() => import("../pages/MarketPlace/pages/MyOrders"));
const TrackOrders = lazy(() => import("../pages/MarketPlace/pages/TrackOrders"));
const OrderDetails = lazy(() => import("../pages/MarketPlace/pages/OrderDetails"));
const ErrorPage = lazy(() => import("../pages/ErrorPage"));
const Farms = lazy(() => import("../pages/Farms"));
const AddFarmPoints = lazy(() => import("../pages/Farms/pages/AddFarmPoints"));
const ViewFarmPoints = lazy(() => import("../pages/Farms/pages/ViewFarmPoints"));
const AddFarmInfo = lazy(() => import("../pages/Farms/pages/AddFarmInfo"));
const FarmReport = lazy(() => import("../pages/Farms/pages/FarmReport"));
const EditFarmPoints = lazy(() => import("../pages/Farms/pages/EditFarmPoints"));
const SignIn = lazy(() => import("../pages/SignIn"));

export const publicRoutes = [
  {
    path: "/",
    elem: <Navigate to="/home" />,
  },
  {
    path: "/authentication",
    elem: <Verification />,
  },
  {
    path: "/verification",
    elem: <CheckUser />,
  },
  {
    path: "/signin",
    elem: <SignIn />,
  },
  {
    path: "/verification/otp-process",
    elem: <OTP />,
  },
];

export const privateRoutes = [
  {
    path: "/home",
    elem: <Home />,
  },
  // ================================= | Crop Routes | =================================
  {
    path: "/your-crops",
    elem: <YourCrops />,
  },
  {
    path: "/crop-details/:id",
    elem: <CropDetails />,
  },
  {
    path: "/crop-details/solution/:id",
    elem: <CropDetailsSolution />,
  },
  // ================================= | Profile Route | =================================
  {
    path: "/personal-info",
    elem: <PersonalInfo />,
  },
  // ================================= | Subscription Routes | =================================
  {
    path: "/subscription",
    elem: <Subscription />,
  },
  {
    path: "/confirm-subscription",
    elem: <ConfirmSubscription />,
  },
  // ================================= | Videos Routes | =================================
  {
    path: "/videos",
    elem: <Videos />,
  },
  {
    path: "/video-player",
    elem: <VideoPlayer />,
  },
  // ================================= | Mandi Route | =================================
  {
    path: "/mandi-rates",
    elem: <MandiRates />,
  },
  // ================================= | Market Place Routes | =================================
  {
    path: "/market",
    elem: <Market />,
  },
  {
    path: "/market/offers",
    elem: <Offers />,
  },
  {
    path: "/market/today-offers",
    elem: <TodayOffers />,
  },
  {
    path: "/market/category/:category",
    elem: <MarketCategory />,
  },
  {
    path: "/market/brand/:brand",
    elem: <MarketBrand />,
  },
  {
    path: "/market/suggested-products",
    elem: <SuggestedProducts />,
  },
  {
    path: "/market/best-selling",
    elem: <BestSelling />,
  },
  {
    path: "/market/product/:productName",
    elem: <ProductPage />,
  },
  {
    path: "/market/cart",
    elem: <MyCart />,
  },
  {
    path: "/market/checkout",
    elem: <Checkout />,
  },
  {
    path: "/market/order-placed/:orderId",
    elem: <OrderPlaced />,
  },
  {
    path: "/market/my-orders",
    elem: <MyOrders />,
  },
  {
    path: "/market/track-orders",
    elem: <TrackOrders />,
  },
  {
    path: "/market/order-details/:orderId",
    elem: <OrderDetails />,
  },
  // ================================= | Crop 2x Routes | =================================
  {
    path: "/farms",
    elem: (
      <Protected>
        <Farms />
      </Protected>
    ),
  },
  {
    path: "/farm/edit-points",
    elem: (
      <Protected>
        <EditFarmPoints />
      </Protected>
    ),
  },
  {
    path: "/farm/add-points",
    elem: (
      <Protected>
        <AddFarmPoints />
      </Protected>
    ),
  },
  {
    path: "/farm/view-points",
    elem: (
      <Protected>
        <ViewFarmPoints />
      </Protected>
    ),
  },
  {
    path: "/farm/add-info",
    elem: (
      <Protected>
        <AddFarmInfo />
      </Protected>
    ),
  },
  {
    path: "/farm/report/:farmTitle",
    elem: (
      <Protected>
        <FarmReport />
      </Protected>
    ),
  },
  // ================================= | Error Route | =================================
  {
    path: "/error-page",
    elem: <ErrorPage />,
  }
];